import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchCriteria } from '@Types/api/common/filters';

interface FilterOptionsState {
  options: Array<string>;
  filterSettings: Array<SearchCriteria>;
}

const initialState: FilterOptionsState = {
  options: [],
  filterSettings: [],
};

const filterOptionsSlice = createSlice({
  name: 'filterOptions',
  initialState,
  reducers: {
    setFilterSettings: (
      state: FilterOptionsState,
      action: PayloadAction<Array<SearchCriteria> | undefined>
    ) => {
      const { payload } = action;

      if (payload === undefined) {
        state.filterSettings = [];
      } else {
        state.filterSettings = payload;
      }
    },
    setFilterOptions: (
      state: FilterOptionsState,
      action: PayloadAction<Array<string> | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.options = [];
      } else {
        state.options = payload;
      }
    },
    removeFilterOption: (
      state: FilterOptionsState,
      action: PayloadAction<string>
    ) => {
      const filteredOptions = state.options.filter(
        (filterItem) => filterItem !== action.payload
      );
      state.options = filteredOptions;
    },
  },
});

const { actions } = filterOptionsSlice;

export const filterOptionsActions = {
  ...actions,
};

export default filterOptionsSlice;
